import React from "react";
import { Table, TableProps } from "antd";
import type { ColumnsType } from "antd/es/table";

export type CampaignTableProps<T> = TableProps<T> & {
  columns: ColumnsType<T>;
  data: T[];
  loading?: boolean;
  pagination?: false | TableProps<T>["pagination"];
  rowKey?: TableProps<T>["rowKey"];
  customPagination?: React.ReactNode;
};

const CampaignTable = <T extends object>({
  columns,
  data,
  loading = false,
  rowKey = "id",
  customPagination,
  className,
  ...rest
}: CampaignTableProps<T>) => {
  const footerProps = customPagination
    ? { footer: () => customPagination }
    : {};

  return (
    <div className="campaign-table-wrapper">
      <Table<T>
        rowKey={rowKey}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
        bordered={false}
        scroll={{ x: 480 }}
        className={`campaign-table ${className || ""}`}
        {...footerProps}
        {...rest}
      />
    </div>
  );
};

export default CampaignTable;
